import { createContext, useContext } from 'react';

// The support modal is owned by DashboardView. Views deep inside it (the
// "talk to us" link on the top-ups page, say) open it through this context
// instead of prop-drilling, optionally seeding the new-request form:
//
//   const { openSupport } = useSupport();
//   openSupport({ prefill: { category: 'question', subject: '…', message: '…' } });
//
// `category` is a SupportModal category id; `subject` gets that category's
// prefix added by the form. The default is a no-op so components still render
// outside the dashboard.
const SupportContext = createContext({ openSupport: () => {} });

export const SupportProvider = SupportContext.Provider;
export const useSupport = () => useContext(SupportContext);
